import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, TextField, DialogActions, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';

export default function AddCustomPrnTemplateDialog({ handleClose, handleSuccess, selectedTemplate }) {
  const { t: tCommon } = useTranslation('common');
  const [data, setData] = useState({
    name: selectedTemplate?.name || '',
    code: selectedTemplate?.code || '',
  });

  const isFormValid = data.name.trim() !== '' && data.code.trim() !== '';

  const handleChange = (field) => (e) => {
    setData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    handleSuccess(data);
    handleClose();
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper} style={{ maxWidth: '600px', width: '90%' }}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>
              {selectedTemplate ? tCommon('Edit Custom PRN Template') : tCommon('Add Custom PRN Template')}
            </h2>
            <CloseIcon onClick={handleClose} className={styles.closeBtn} />
          </div>

          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={3} sm={3} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Template Name')}</h3>
              </Grid>
              <Grid item xs={9} sm={9}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.name}
                  onChange={handleChange('name')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="flex-start" mt={2}>
              <Grid item xs={3} sm={3} className={styles.inputLabelContainer} style={{ paddingTop: '8px' }}>
                <h3 className={styles.inputLabel}>{tCommon('PRN Code')}</h3>
              </Grid>
              <Grid item xs={9} sm={9}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  minRows={8}
                  maxRows={15}
                  value={data.code}
                  onChange={handleChange('code')}
                />
              </Grid>
            </Grid>

            <DialogActions style={{ marginTop: '16px' }}>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                onClick={handleSubmit}
                disabled={!isFormValid}
              >
                {selectedTemplate ? tCommon('Update') : tCommon('Add')}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
